/* Hole Cards */
import 'slick-carousel';

export function hole_cards() {

	( ( $ ) => {

		const init = () => {

			if ( $( '.block--hole-cards' ).length <= 0 ) {
				return;
			}

			$( '.block--hole-cards' ).each( ( i, e ) => {
				const wrapper = $( e );
				const slider = wrapper.find( '.row' );
				const prevButton = wrapper.find( '.custom-slick-navigation.prev' );
				const nextButton = wrapper.find( '.custom-slick-navigation.next' );
				
				slider.slick( {
					arrows: true,
					infinite: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					draggable: true,
					prevArrow: prevButton,
					nextArrow: nextButton,
					fade: true,
					rows: 0,
				} );
			} );
		}

		if ( $( window ).width() <= 992 ) {
			init();
		}

	} )( window.jQuery );
}
